import { Context } from '@alltrails/shared/types/context';
import ApplicationLayout from 'components/ApplicationLayout';
import Checkout from 'components/Checkout';
import MinimalLayout from 'components/MinimalLayout';
import Coupon from 'types/Coupon';
import CurrencyCode from 'types/CurrencyCode';
import PaymentMethod from 'types/PaymentMethod';
import Plan from 'types/Plan';
import { activate } from 'utils/OptimizelyHelpers';
import LegacyCheckout from './LegacyCheckout';

type Props = {
  annualPlan: Plan;
  context: Context;
  coupon: Coupon;
  currencyCode: CurrencyCode;
  currentPage: string;
  locationSlug: string;
  paymentTypes: PaymentMethod[];
  plans: Plan[];
  recurlyPublicKey: string;
  userId: number;
  web_growth_pro_checkout_page_v1: null | 'control' | 'new_checkout';
  wideFooter: boolean;
};

export default function CheckoutRoute({
  context,
  currentPage,
  locationSlug,
  wideFooter,
  annualPlan,
  coupon,
  currencyCode,
  paymentTypes,
  plans,
  recurlyPublicKey,
  userId,
  web_growth_pro_checkout_page_v1
}: Props) {
  const variation = web_growth_pro_checkout_page_v1 ?? activate('web_growth_pro_checkout_page_v1');

  if (variation === 'new_checkout') {
    return (
      <MinimalLayout>
        <Checkout
          annualPlan={annualPlan}
          coupon={coupon}
          currencyCode={currencyCode}
          initialPlan={plans[0]}
          recurlyPublicKey={recurlyPublicKey}
          userId={userId}
        />
      </MinimalLayout>
    );
  }

  return (
    <ApplicationLayout context={context} currentPage={currentPage} locationSlug={locationSlug} wideFooter={wideFooter}>
      <LegacyCheckout
        annualPlan={annualPlan}
        coupon={coupon}
        currencyCode={currencyCode}
        paymentTypes={paymentTypes}
        plans={plans}
        recurlyPublicKey={recurlyPublicKey}
        userId={userId}
      />
    </ApplicationLayout>
  );
}
